import React from 'react';
import { colors } from '@/theme';
import ItemComments from '@/components/shared-views/item-comments';
import * as Enums from '@/utils/enums';
import AuditLog from '@/components/shared-views/audit-log';
import constants from '@/utils/constants';
import CustomerForm from "@/components/customer/CustomerForm";
import CustomerPrimaryPickers from "@/components/customer/primary-picker/CustomerPrimaryPickers";
import {Space} from "@mantine/core";

function CustomerDetails(props: any) {

  const {
    customer,
    saveToggle,
    triggerSaveComment,
  } = props

  // const [customerType, setCustomerType] = useState(customer.IsCompany ? 'Company' : 'Individual');

  return (

      <div>
        <Space h={10} />

        <CustomerForm
            {...props}
            // Hiding/showing is done from the status tag next to the breadcrumbs
            showActiveToggle={false}
            contactSection={
              <CustomerPrimaryPickers
                  customer={customer}
                  updateCustomer={props.updateCustomer}
                  accessStatus={props.accessStatus}
              />
            }
        />

        <div className="comments-and-history">
          <ItemComments
              itemID={customer.ID}
              module={Enums.Module.Customer}
              storeID={customer.StoreID}
              triggerSave={triggerSaveComment}
              {...{} as any}
          />

          <AuditLog recordID={customer.ID} retriggerSearch={saveToggle}/>
        </div>

        <style jsx>{`
          .inner-container {
            margin-top: 2.5rem;
            position: relative;
          }

          .row {
            display: flex;
          }

          .column {
            display: flex;
            flex-basis: 0;
            flex-direction: column;
            flex-grow: 1;
          }

          .column :global(.textarea-container) {
            height: 100%;
          }

          .column + .column {
            margin-left: 1.25rem;
          }

          .switch {
            flex-direction: row-reverse;
            display: flex;
            flex-basis: 0;
            flex-grow: 1;
          }

          .contact {
            color: ${colors.blueGrey};
            padding-right: 5rem;
            position: relative;
            width: fit-content;
          }

          .contact h1 {
            color: ${colors.darkPrimary};
            font-size: 2rem;
            margin: 0 0 0.75rem;
          }

          .contact p {
            margin: 3px 0 0;
            opacity: 0.8;
          }

          .contact strong {
            color: ${colors.darkPrimary};
            margin-bottom: 0.5rem;
          }

          .contact + .contact {
            margin-top: 1rem;
          }

          .edit {
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
          }

          .heading-row {
            display: flex;
          }

          .heading {
            color: ${colors.blueGrey};
            font-weight: bold;
            margin: 1.5rem 0 0.5rem;
          }

          .customer-type {
            margin-left: 1rem;
            margin-top: 0.9rem;
          }

          .status {
            position: absolute;
            right: 0;
            top: 0;
            width: 20rem;
          }

          .status :global(.input-container) {
            background-color: ${colors.bluePrimary};
          }

          .status :global(input) {
            color: ${colors.white};
          }

          .status :global(label) {
            color: ${colors.white};
            opacity: 0.8;
          }

          .comments-and-history {
            padding-right: 3rem;
          }

          .form-width-container {
            max-width: ${constants.maxFormWidth};
          }
        `}</style>
      </div>
  );
}

export default CustomerDetails;
